import * as React from "react";
import { useInviteModal } from "./useInviteModal";
import Select from "react-select";
import {
  AsButton,
  reactSelectStyles,
  AsInput,
  AsIconButton,
  DialogLayout,
} from "app/subframe";
import {InputEdit} from "../../components/inputEdit/InputEdit";
import {Save} from "lucide-react";

export interface InviteModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export const InviteModal: React.FC<InviteModalProps> = ({
  isOpen,
  onOpenChange,
}) => {
  const { onSubmit, isLoading, employeeCode, setEmployeeCode } = useInviteModal({
    onOpenChange,
  });

  const roleOptions = [
    { value: "admin", label: "Admin" },
    { value: "employee", label: "Employee" },
  ];

  return (
    <DialogLayout
      open={isOpen}
      onOpenChange={onOpenChange}
      className="rounded px-8 z-[1000]"
    >
      <div className="flex relative flex-col py-10 h-[470px] w-144 pt-[18px] mobile:w-full items-center px-8">
        <AsIconButton
          name="FeatherX"
          variant="ghost"
          size="xs"
          className="absolute top-4 right-4"
          onClick={() => onOpenChange(false)}
        />

        <h2 className="text-xl w-full font-semibold mb-8">
          Add New Staff Member
        </h2>

        <form className="flex flex-col w-full gap-5" onSubmit={onSubmit}>
          <AsInput
            label="Name"
            name="name"
            placeholder="Enter name"
            textPosition="left"
            required
          />

          <AsInput
            label="Email"
            name="email"
            type="email"
            placeholder="Enter email"
            textPosition="left"
            required
          />

          <AsInput
            label="Employee Code"
            name="employeeCode"
            placeholder="Enter code"
            textPosition="left"
            value={employeeCode}
            onChange={(e: any) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 5);
              setEmployeeCode(value);
            }}
            required
          />
          {/*<AsInput*/}
          {/*    label="Phone"*/}
          {/*    name="phone"*/}
          {/*    type="phone"*/}
          {/*    placeholder="Enter Phone"*/}
          {/*    textPosition="left"*/}
          {/*    required*/}
          {/*/>*/}

          {/*<div className="flex flex-col gap-2">*/}
          {/*  <label className="text-zinc-500 text-sm">*/}
          {/*    Role of new user <span className="text-red-500">*</span>*/}
          {/*  </label>*/}
          {/*  <Select*/}
          {/*      isDisabled*/}
          {/*    options={[*/}
          {/*      { value: "admin", label: "Admin" },*/}
          {/*      { value: "employee", label: "Employee" },*/}
          {/*    ]}*/}
          {/*      // defaultValue='employee'*/}
          {/*    name="role"*/}
          {/*    placeholder="Select role"*/}
          {/*    styles={reactSelectStyles({*/}
          {/*      borderContainer: true,*/}
          {/*    })}*/}
          {/*    required*/}
          {/*  />*/}
          {/*</div>*/}
          <div className="flex flex-col gap-2">
            <label className="text-zinc-500 text-sm">
              Role of new user <span className="text-red-500">*</span>
            </label>

            <Select
                isDisabled
                name="role"
                options={roleOptions}
                defaultValue={roleOptions[1]} // ✅ Employee
                placeholder="Select role"
                styles={reactSelectStyles({
                  borderContainer: true,
                })}
                required
            />
          </div>

          {/*<div>*/}
          {/*  <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>*/}
          {/*  <select*/}
          {/*      value={'active'}*/}
          {/*      // onChange={(e) => setNewStaff(prev => ({*/}
          {/*      //   ...prev,*/}
          {/*      //   status: e.target.value as 'active' | 'inactive'*/}
          {/*      // }))}*/}
          {/*      onChange={()=>{}}*/}
          {/*      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
          {/*  >*/}
          {/*    <option value="active">Active</option>*/}
          {/*    <option value="inactive">Inactive</option>*/}
          {/*  </select>*/}
          {/*</div>*/}



<div className={'flex justify-end space-x-3 pt-4 border-t border-gray-200 mb-4'}>

  <button
      onClick={() => onOpenChange(false)}
      className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
  >
    Cancel
  </button>

  <AsButton
      type="submit"
      className="border-none px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center space-x-2"
      disabled={isLoading}
      text="Add Staff"
      loader={isLoading}
  />

</div>

        </form>
      </div>
    </DialogLayout>
  );
};
